/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute.jsx';

import NavigationTopComponent from './navigation/NavigationTop';

import PricingComponent from './Pricing';
import TermsComponent from './Terms';
import PrivacyComponent from './Privacy';
import AirCheckComponent from './AirCheck';
import NotEnabledComponent from './NotEnabled';
import HelpComponent from './Help';
import SigninComponent from './Signin';
import SignupComponent from './Signup';
import SignupSonosComponent from './SignupSonos';

// import TodoComponent from './Todo';
// import DashboardComponent from './Dashboard';
// import JobsComponent from './Jobs';
// import AssetsComponent from './Assets';
import AppPublicComponent from './AppPublic';
import AppAssetsComponent from './assets/AppAssets';
import AppIngestComponent from './ingest/App';
import AppChannelsComponent from './channels/App';
import PropTypes from 'prop-types';


@inject('auth') @observer
class App extends React.Component {
    render() {
        if (this.props.auth) {
            console.log('Authentication isLoggedIn', this.props.auth.isLoggedIn, this.props.auth.isLoggingIn);
        } else {
            console.log('Authentication not set yet.');
        }
        return (
            <BrowserRouter>
                <div className="dashboard">
                    <NavigationTopComponent />
                    <div className="container-fluid">

                        <Switch>
                            <PrivateRoute path="/home" name="AppPublic" component={AppPublicComponent} />
                            <PrivateRoute path="/assets" component={AppAssetsComponent} />
                            <PrivateRoute path="/channels" component={AppChannelsComponent} />
                            <PrivateRoute path="/ingest" component={AppIngestComponent} />

                            <Route exact path="/help" component={HelpComponent} />
                            <Route exact path="/terms" component={TermsComponent} />
                            <Route exact path="/privacy" component={PrivacyComponent} />
                            <Route exact path="/notenabled" component={NotEnabledComponent} />
                            <Route exact path="/login" component={SigninComponent} />
                            <Route exact path="/signup" component={SignupComponent} />
                            <Route exact path="/signupsonos" component={SignupSonosComponent} />

                            <Redirect path="*" to="/login" />
                        </Switch>
                    </div>
                </div>
            </BrowserRouter>
        );
    }
}

App.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
};

export default App;
